import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'

function Buttons(props){
  const [strings] = useEnvValue('strings')
  const [checked,setChecked] = useEnvValue('planting.checked',false)

  return (
        <div className="buttons">
          <label htmlFor="hedge-plant">
            <input type="radio" name={'planting_checked'} defaultChecked={checked} onChange={() => setChecked(true)}/>
              <span>{strings.yes}</span>
          </label>
          <label htmlFor="hedge-plant">
            <input type="radio" name={'planting_checked'} defaultChecked={!checked} onChange={() => setChecked(false)}/>
              <span>{strings.no}</span>
          </label>
        </div>
  )
}

export default observer(Buttons)